import { AMP_ADD_TO_CART_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import Button from "component/design-system/buttons/Button";
import ProducItemDetailedCommon from "component/product/ProducItemDetailedCommon";
import AddToCartContainer from "component/product/V2/add-to-cart/AddToCartContainer";
import ProductBadge from "component/product/desktop-badge/ProductBadge";
import { IVehcileDefaultValues } from "interfaces/session/IVehicle";
import SafeLink from "modules/components/SafeLink";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import HideIf from "util/HideIf";
import enhancedEcommerce from "util/enhanced-ecommerce";
import getCustomSizeQuery from "util/url/getCustomSizeQuery";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import CategoryFitmentContainer from "../../../modules/fitment/CategoryFitmentContainer";
import { toLowerCase } from "../../../util/lodash/toLowerCase";
import CategoryPrice from "../CategoryPrice";
import ProductDetails from "../product-cards/ProductDetails";
import ProductImage from "../product-cards/ProductImage";
import styles from "./productDetailCard.module.scss";
const ProductHighlightsV2 = dynamic(() => import(/* webpackChunkName: "product-highlights-v2" */ "component/product/V2/product-highlights/ProductHighlightsV2"));

interface IProps {
  product: ICompactProduct;
  defaultVehicle: IVehcileDefaultValues;
}

function ProductDetailCard(props: IProps) {
  const {
    product, defaultVehicle, fitmentOptionsDetails,
  } = props;
  const { t } = useTranslation("category");

  const {
    pickUpAvailable, shippingAvailable, productHighlights, canonicalUrl,
  } = product;
  const customSizes = getCustomSizeQuery();
  // const { href, asPath } = getHrefAndPath({ asPath: canonicalUrl });
  const { href, asPath } = getHrefAndPath({ asPath: canonicalUrl, query: { ...customSizes } });

  const { enCategory } = product;
  const { tier0 } = enCategory || {};

  const productHighlightsArray = productHighlights && productHighlights.length > 1 ? productHighlights.slice(1, 3) : [];

  return (
    <div className={styles.card_container}>
      <ProductImage
        product={product}
        productHighlights={productHighlights}
        hrefProps={href}
        asPathProps={asPath}
      />
      <div className={styles.product_description}>
        <ProductDetails
          product={product}
          hrefProps={href}
          asPathProps={asPath}
          isListView
        />
        <CategoryFitmentContainer
          product={product}
          defaultVehicle={defaultVehicle}
          fitmentOptionsDetails={fitmentOptionsDetails}
          validateFitment
        />
        <div className={styles.deliveryOption}>
          <ProductBadge
            product={product}
          />
        </div>

      </div>

      <div className="d-flex flex-column">
        <div className="m-t-10">
          <CategoryPrice product={product} isListView />
        </div>
        <div className="m-b-10">
          <HideIf show={toLowerCase(tier0) !== "wheels & tires" && productHighlightsArray.length}>
            <ProductHighlightsV2
              productHighlights={productHighlightsArray}
              hideBulletPoints
            />
          </HideIf>
          <HideIf show={toLowerCase(tier0) === "wheels & tires"}>

            <ProducItemDetailedCommon
              showMore
              product={product}
              accordionColor="grey"
              sliceInfo={3}
            />

          </HideIf>
        </div>

        <div className={styles.btn_cart}>
          <SafeLink href={href} asPath={asPath}>
            <Button
              variant="primary-outline"
              fullWidth
              onClick={() => enhancedEcommerce.onProductClick(product)}
            >
              {t("View Details")}
            </Button>
          </SafeLink>
          <AddToCartContainer
            product={product}
            label={t("Add to Cart")}
            addingToCartLocation={
              AMP_ADD_TO_CART_LOCATIONS.HORIZONTAL_PRODUCT_CARD
            }
            classActionContainer={styles.class_action_container}
            {...{
              pickUpAvailable,
              shippingAvailable,
            }}
            showQuantity={false}
          />
        </div>

      </div>
    </div>
  );
}

export default ProductDetailCard;
